import { render } from "./terms-onprem.vue?vue&type=template&id=66e8e407&ts=true"
import script from "./terms-onprem.vue?vue&type=script&lang=ts"
export * from "./terms-onprem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__